export default "__VITE_ASSET__DbOsJvkT__"